let language = {
    DETAIL_ROOT_CATALOG: "Products"
}

export { language }